module.exports = __webpack_public_path__ + "media/images/flags/4x3/aze-302b01b551265d2c3ffabf706b65760c.svg";